module.exports = "mutation ($id: ID!) {\n  ModelTemplateDelete(id: $id) {\n    id\n  }\n}\n"